var _desc, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIlDotsRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "138px",
    height: "88px",
    viewBox: "0 0 138 88",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "il-dots-right") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "QBCS---Pages",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "QBCS-IM-Homepage-v2-desktop",
    transform: "translate(-1286.000000, -415.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "HERO",
    transform: "translate(65.000000, 220.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "il-dots-lright",
    transform: "translate(1221.000000, 195.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(69.000000, 44.000000) scale(-1, -1) translate(-69.000000, -44.000000) "
  }, /*#__PURE__*/React.createElement("path", {
    d: "M122,18.5 C122,19.8806875 120.880688,21 119.5,21 C118.119313,21 117,19.8806875 117,18.5 C117,17.1193125 118.119313,16 119.5,16 C120.880688,16 122,17.1193125 122,18.5 Z",
    id: "Fill-1",
    fill: "#D4D7DC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122,2.5 C122,3.8806875 120.880688,5 119.5,5 C118.119313,5 117,3.8806875 117,2.5 C117,1.1193125 118.119313,0 119.5,0 C120.880688,0 122,1.1193125 122,2.5 Z",
    id: "Fill-3",
    fill: "#53B700"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104,36.5 C104,37.8807125 102.880688,39 101.5,39 C100.119313,39 99,37.8807125 99,36.5 C99,35.1193125 100.119313,34 101.5,34 C102.880688,34 104,35.1193125 104,36.5 Z",
    id: "Fill-4",
    fill: "#D4D7DC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122,36.5 C122,37.8807125 120.880688,39 119.5,39 C118.119313,39 117,37.8807125 117,36.5 C117,35.1193125 118.119313,34 119.5,34 C120.880688,34 122,35.1193125 122,36.5 Z",
    id: "Fill-5",
    fill: "#D4D7DC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5,51.5 C5,52.8807125 3.88071187,54 2.5,54 C1.11928812,54 0,52.8807125 0,51.5 C0,50.1192875 1.11928812,49 2.5,49 C3.88071187,49 5,50.1192875 5,51.5 Z",
    id: "Fill-6",
    fill: "#D4D7DC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21,51.5 C21,52.8807125 19.8807125,54 18.5,54 C17.1192875,54 16,52.8807125 16,51.5 C16,50.1192875 17.1192875,49 18.5,49 C19.8807125,49 21,50.1192875 21,51.5 Z",
    id: "Fill-7",
    fill: "#D4D7DC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39,51.5 C39,52.8807125 37.8807125,54 36.5,54 C35.1192875,54 34,52.8807125 34,51.5 C34,50.1192875 35.1192875,49 36.5,49 C37.8807125,49 39,50.1192875 39,51.5 Z",
    id: "Fill-8",
    fill: "#D4D7DC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55,51.5 C55,52.8807125 53.8806875,54 52.5,54 C51.1192875,54 50,52.8807125 50,51.5 C50,50.1192875 51.1192875,49 52.5,49 C53.8806875,49 55,50.1192875 55,51.5 Z",
    id: "Fill-9",
    fill: "#53B700"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71,51.5 C71,52.8807125 69.8806875,54 68.5,54 C67.1193125,54 66,52.8807125 66,51.5 C66,50.1192875 67.1193125,49 68.5,49 C69.8806875,49 71,50.1192875 71,51.5 Z",
    id: "Fill-10",
    fill: "#D4D7DC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88,51.5 C88,52.8807125 86.8806875,54 85.5,54 C84.1193125,54 83,52.8807125 83,51.5 C83,50.1192875 84.1193125,49 85.5,49 C86.8806875,49 88,50.1192875 88,51.5 Z",
    id: "Fill-11",
    fill: "#D4D7DC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104,51.5 C104,52.8807125 102.880688,54 101.5,54 C100.119313,54 99,52.8807125 99,51.5 C99,50.1192875 100.119313,49 101.5,49 C102.880688,49 104,50.1192875 104,51.5 Z",
    id: "Fill-12",
    fill: "#D4D7DC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122,51.5 C122,52.8807125 120.880688,54 119.5,54 C118.119313,54 117,52.8807125 117,51.5 C117,50.1192875 118.119313,49 119.5,49 C120.880688,49 122,50.1192875 122,51.5 Z",
    id: "Fill-13",
    fill: "#D4D7DC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71,69.5 C71,70.8807125 69.8806875,72 68.5,72 C67.1193125,72 66,70.8807125 66,69.5 C66,68.1192875 67.1193125,67 68.5,67 C69.8806875,67 71,68.1192875 71,69.5 Z",
    id: "Fill-14",
    fill: "#53B700"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88,69.5 C88,70.8807125 86.8806875,72 85.5,72 C84.1193125,72 83,70.8807125 83,69.5 C83,68.1192875 84.1193125,67 85.5,67 C86.8806875,67 88,68.1192875 88,69.5 Z",
    id: "Fill-15",
    fill: "#D4D7DC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104,69.5 C104,70.8807125 102.880688,72 101.5,72 C100.119313,72 99,70.8807125 99,69.5 C99,68.1192875 100.119313,67 101.5,67 C102.880688,67 104,68.1192875 104,69.5 Z",
    id: "Fill-16",
    fill: "#D4D7DC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122,69.5 C122,70.8807125 120.880688,72 119.5,72 C118.119313,72 117,70.8807125 117,69.5 C117,68.1192875 118.119313,67 119.5,67 C120.880688,67 122,68.1192875 122,69.5 Z",
    id: "Fill-17",
    fill: "#D4D7DC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138,69.5 C138,70.8807125 136.880688,72 135.5,72 C134.119313,72 133,70.8807125 133,69.5 C133,68.1192875 134.119313,67 135.5,67 C136.880688,67 138,68.1192875 138,69.5 Z",
    id: "Fill-18",
    fill: "#D4D7DC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55,85.5 C55,86.8807119 53.8806875,88 52.5,88 C51.1192875,88 50,86.8807119 50,85.5 C50,84.1192881 51.1192875,83 52.5,83 C53.8806875,83 55,84.1192881 55,85.5 Z",
    id: "Fill-19",
    fill: "#D4D7DC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71,85.5 C71,86.8807119 69.8806875,88 68.5,88 C67.1193125,88 66,86.8807119 66,85.5 C66,84.1192881 67.1193125,83 68.5,83 C69.8806875,83 71,84.1192881 71,85.5 Z",
    id: "Fill-20",
    fill: "#D4D7DC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88,85.5 C88,86.8807119 86.8806875,88 85.5,88 C84.1193125,88 83,86.8807119 83,85.5 C83,84.1192881 84.1193125,83 85.5,83 C86.8806875,83 88,84.1192881 88,85.5 Z",
    id: "Fill-21",
    fill: "#D4D7DC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104,85.5 C104,86.8807119 102.880688,88 101.5,88 C100.119313,88 99,86.8807119 99,85.5 C99,84.1192881 100.119313,83 101.5,83 C102.880688,83 104,84.1192881 104,85.5 Z",
    id: "Fill-22",
    fill: "#D4D7DC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.1,67 L135.9,67 C137.059778,67 138,68.1192875 138,69.5 L138,69.5 C138,70.8807125 137.059778,72 135.9,72 L119.1,72 C117.940223,72 117,70.8807125 117,69.5 L117,69.5 C117,68.1192875 117.940223,67 119.1,67 Z",
    id: "Fill-23",
    fill: "#53B700"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.1,49 L18.9,49 C20.0597985,49 21,50.1192875 21,51.5 L21,51.5 C21,52.8807125 20.0597985,54 18.9,54 L2.1,54 C0.9402015,54 0,52.8807125 0,51.5 L0,51.5 C0,50.1192875 0.9402015,49 2.1,49 Z",
    id: "Fill-24",
    fill: "#D8D8D8"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIlDotsRight);
export default __webpack_public_path__ + "static/media/il-dots-right.b81ece528bd00efde895cab2cea64dd4.svg";
export { ForwardRef as ReactComponent };